import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { SessionProvider } from './lib/session.jsx';
import { ThemeProvider } from './lib/theme.jsx';
import { isNative } from './lib/supabase.js';
import { affiliate } from './lib/api.js';
import './styles/index.css';

// The stylesheet tightens the shell (single scroller, no zoom/selection) under html.native.
if (isNative()) document.documentElement.classList.add('native');

// An invite link (…/?ref=CODE) remembers its code until the account exists.
const ref = new URLSearchParams(window.location.search).get('ref');
if (ref) affiliate.remember(ref);

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
